import type { ComponentType, FC } from 'react';

import { type InputBaseComponentProps } from '@material-ui/core/InputBase'
import { type MaskedInputProps } from 'react-text-mask'

import { TextField as FormTextField } from './TextField'
import { type ITextFieldProps } from '../../elements/TextField/'
import { MaskedInput } from '@ui/elements/MaskedInput'

export type IMaskedTextFieldWithFormik = Pick<
  MaskedInputProps,
  'mask' | 'placeholderChar' | 'keepCharPositions' | 'showMask'
> &
  ITextFieldProps

const MaskedField: FC<InputBaseComponentProps> = (props) => {
  const { mask, placeholderChar, keepCharPositions, showMask, ...maskProps } =
    props as MaskedInputProps

  return (
    <MaskedInput
      {...maskProps}
      mask={mask}
      placeholderChar={placeholderChar ? placeholderChar : '\u2000'}
      keepCharPositions={keepCharPositions ? keepCharPositions : false}
      showMask={showMask ? showMask : false}
    />
  )
}

export const FormMaskedTextField: ComponentType<
  IMaskedTextFieldWithFormik
> = (props) => {
  const {
    mask,
    placeholderChar,
    keepCharPositions,
    showMask,
    name,
    ...otherProps
  } = props

  return (
    <FormTextField
      name={name}
      InputProps={{ inputComponent: MaskedField }}
      inputProps={{ mask, placeholderChar, keepCharPositions, showMask }}
      {...otherProps}
    />
  )
}

FormMaskedTextField.displayName = 'Form.MaskedTextField'
